import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig, { IA_PEOPLE_MENU_GROUP } from '../../../config/authConfig';
import { LeavesHistoryStore } from '../store/leavesHistoryStore';
import { ChangeReasonsStore, StatusHistoryDialogChangeReasonsStore } from '../../Employee/store/changeReasonsStore';
import { LEAVES_PAGE_LOCALE_PATH } from '../../Employee/locales';

export const LeavesRoutes = {
  default: 'leaves',
};

export const LeavesPageConfig: ReactPageConfig = {
  name: `${LEAVES_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: LeavesRoutes.default,
  allowedRoles: [authConfig.roles.ADMIN],
  component: lazy(() => import('../components/LeavesPage')),
  storeDependencies: [
    { store: LeavesHistoryStore },
    { store: ChangeReasonsStore },
    { store: StatusHistoryDialogChangeReasonsStore },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/BeachAccess')),
    label: `${LEAVES_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: IA_PEOPLE_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
